import axios from "axios";
import * as constants from '../config/constanst';
class AuthService {
    login(username, password) {
        return axios
            .post(constants.API_END_POINT + constants.GET_TOKEN_API, {
                username,
                password
            })
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }
    logout() {
        localStorage.removeItem("user");
    }
    register(username, email, password) {
        return axios.post(constants.API_END_POINT + constants.SIGNUP_API, {
            username,
            email,
            password
        });
    }
    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'));;
    }

}

export default new AuthService();
